import { FormattedMessage } from 'dibs-react-intl';

const frontDoorTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.frontDoorTooltip"
        defaultMessage="Delivered to the first available dry area outside of your house or building (front door, porch, landing area, garage, etc.)."
    />
);

const courierTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.courierTooltip"
        defaultMessage="Item collected and hand-delivered via a local courier service."
    />
);

const expressTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.expressTooltip"
        defaultMessage="Delivered by a parcel delivery service such as UPS, FedEx, or DHL."
    />
);

const standardTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.standardTooltip"
        defaultMessage="Delivered by a parcel delivery service such as UPS, FedEx, or DHL."
    />
);

const whiteGloveTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.whiteGloveTooltip"
        defaultMessage="Delivered by appointment to the room of your choice."
    />
);

const expeditedWhiteGloveTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.expeditedWhiteGloveTooltip"
        defaultMessage="Delivered by appointment to the room of your choice."
    />
);

export const shippingMethodDescriptions = {
    FREIGHT: {
        FRONT_DOOR: frontDoorTooltipMessage,
    },
    GROUND_FREIGHT: {
        STANDARD: frontDoorTooltipMessage,
        EXPRESS: frontDoorTooltipMessage,
    },
    AIR_FREIGHT: {
        STANDARD: frontDoorTooltipMessage,
        EXPRESS: frontDoorTooltipMessage,
    },
    SEA_FREIGHT: {
        STANDARD: frontDoorTooltipMessage,
    },
    PARCEL: {
        MESSENGER: courierTooltipMessage,
        EXPRESS: expressTooltipMessage,
        STANDARD: standardTooltipMessage,
    },
    WHITE_GLOVE: {
        STANDARD: whiteGloveTooltipMessage,
        EXPRESS: expeditedWhiteGloveTooltipMessage,
    },
};
